import { ColumnsType } from 'antd/lib/table/interface';
import { TimesheetStatusReportDetailModel } from 'api/backofficeApiClient';
import { TimesheetStatusReportHiddenColumns } from '../features/home/UserHomePage/enums';

interface TimesheetStatusReportTableColumnsOptions {
  columns: ColumnsType<TimesheetStatusReportDetailModel>;
  isCorporateTA?: boolean;
  isAdmin?: boolean;
}

const getTimesheetStatusReportTableColumns = ({
  columns,
  isAdmin,
  isCorporateTA,
}: TimesheetStatusReportTableColumnsOptions) => {
  if (isAdmin) {
    return columns;
  }

  // Hide member column for member
  if (!isCorporateTA) {
    return columns.filter(
      (item) => item.key !== TimesheetStatusReportHiddenColumns.Member,
    );
  }

  // Hide member and customer columns for corporate TA
  return columns.filter(
    (item) =>
      item.key !== TimesheetStatusReportHiddenColumns.Customer &&
      item.key !== TimesheetStatusReportHiddenColumns.Member,
  );
};

export { getTimesheetStatusReportTableColumns };
